module.exports = __webpack_public_path__ + "img/clock.01ea80bb.svg";